<template>
  <div>
    <div class="text-h6 mt-2 mb-4">Procéder à un remboursement</div>
    <div v-if="inscription.refunds && inscription.refunds.length > 0">
      <div>Somme déjà remboursée : {{ already_refunded }}€</div>
    </div>

    <div class="mt-2">Action a effectuer</div>
    <v-btn-toggle color="primary-dark" variant="outlined" mandatory v-model="refund.action">
      <v-btn value="refund_and_delete"> Rembourser et supprimer l'inscription </v-btn>
      <v-btn value="refund_and_keep"> Rembourser et conserver l'inscription </v-btn>
      <v-btn v-if="mainStore.authAdmin.isSportipsAdmin && inscription.gia" value="refund_with_gia"> Remboursement
        GIA </v-btn>
    </v-btn-toggle>
    <v-row>
      <v-col>
        <v-sheet class="pa-2 my-2" border color="grey-lighten-5" elevation="0">
          <div v-if="refund.action == 'refund_and_delete'" class="font-italic">
            <v-icon icon="mdi-delete-outline" color="primary-dark"></v-icon>
            <span>L'inscription du participant sera annulée, il sera remboursé <span
                v-if="mainStore.authAdmin.isSportipsAdmin">d'une partie ou </span>de la totalité de
              l'inscription</span>
          </div>
          <div v-if="refund.action == 'refund_and_keep'" class="font-italic">
            <v-icon icon="mdi-check" color="primary-dark"></v-icon>
            <span>L'inscription du participant sera conservée, il sera remboursé d'une partie ou de la totalité de
              l'inscription</span>
          </div>
          <div v-if="refund.action == 'refund_with_gia'" class="font-italic">
            <v-icon icon="mdi-delete-outline" color="primary-dark"></v-icon>
            <span>L'inscription du participant sera annulée, il sera remboursé du prix de son parcours</span>
          </div>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="5">

        <v-text-field class="mt-4" v-model="refund.amount_to_refund" @update:modelValue="updateAmountToRefund"
          label="Montant à rembourser" type="number" min="0" :max="max_refundable_per_user" outlined
          append-inner-icon="mdi-currency-eur"></v-text-field>
        <div>Somme remboursable : {{ refund.amount_refundable }}€</div>
        <div>Montant de l'inscription après remboursement : {{ refund.amount_after_refund }}€</div>
      </v-col>
    </v-row>

    <v-row v-if="!refund_allowed">
      <v-col class="d-flex justify-center">
        <v-alert class="mt-2" border="start" border-color="red" elevation="0">Il n'est plus possible d'effectuer de
          remboursement après la date de l'évènement</v-alert>
      </v-col>
    </v-row>
    <v-row v-else-if="is_commande_admin">
      <v-col class="d-flex justify-center">
        <v-alert class="mt-2" border="start" border-color="red" elevation="0">Il n'est pas possible de rembourser une
          commande administrateur</v-alert>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col class="d-flex justify-center">
        <v-btn v-if="!onload" class="sm-fullwidth mt-2 inscription_btn" color="primary-dark"
          @click="display_confirm_dialog = true">Procéder au remboursement de {{ refund.amount_to_refund }}€</v-btn>
        <v-progress-circular v-else indeterminate color="primary-dark"></v-progress-circular>
      </v-col>
    </v-row>





    <!-- DIALOG CONFIRMATION -->
    <v-dialog v-model="display_confirm_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Confirmer le remboursement</div>
          <p>
            Vous êtes sur le point de procéder à un remboursement de <b>{{ refund.amount_to_refund }}€</b> pour
            l'inscription de <b>{{ inscription.nom }} {{ inscription.prenom }}</b>.
            <span v-if="refund.action == 'refund_and_delete'">L'inscription sera <b>annulée</b>.</span>
            <span v-if="refund.action == 'refund_and_keep'">L'inscription sera <b>conservée</b>.</span>
            <span v-if="refund.action == 'refund_with_gia'">L'inscription sera <b>annulée</b>.</span>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary-dark" text @click="display_confirm_dialog = false">Annuler</v-btn>
          <v-btn color="primary-dark" text @click="proceed_to_refund()">Confirmer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- DIALOG REPONSE -->
    <v-dialog v-model="display_response_dialog" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <div class="text-h6">Votre demande de remboursement</div>
          <div v-if="response_refund == null">Une erreur est survenue. Veuillez contacter le support
            Sportips.</div>
          <div v-if="response_refund == false">{{ refund.error }}</div>
          <div v-else>
            <div v-if="!response_refund.refund_possible">
              Le remboursement n'a pas pu être effectuée. Les fonds sur la commande associée à cette inscription sont
              insuffisants.
              <div class="field_label">Montant remboursé : {{ response_refund.amount_refunded }}€</div>
              <div class="field_label">Montant restant à rembourser : {{ response_refund.amount_not_refunded }}€</div>
            </div>
            <div v-else>
              <div v-if="response_refund.amount_to_refund != response_refund.amount_refunded">
                Le remboursement n'a pas pu être effectué intégralement. Le remboursement d'une des transactions a
                echoué (problème de communication banque...).
                <div class="field_label">Montant remboursé : {{ response_refund.amount_refunded }}€</div>
                <div class="field_label">Montant restant à rembourser : {{ response_refund.amount_not_refunded }}€</div>
              </div>
              <div v-else>
                Le remboursement a été effectué avec succès.
                <div class="field_label">Montant remboursé : {{ response_refund.amount_refunded }}€</div>
              </div>
            </div>
            <div>Un email a été envoyé au participant pour l'informer de son remboursement.</div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary-dark" text @click="handle_close_response_dialog()">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service";
import Inscription_Refund from "@/classes/Refund/Inscription_Refund.class.js";

export default {
  props: ["item"],
  data() {
    return {
      commande: null,
      display_confirm_dialog: false,
      display_response_dialog: false,
      inscription: {},
      refund: new Inscription_Refund(),
      response_refund: {},
      onload: false,
    };
  },
  watch: {
    "refund.action"() {
      this.refund.setAmountRefundable(this.inscription);
    },
  },
  computed: {
    ...mapStores(useMainStore),
    max_refundable_per_user() {
      let is_sportips_admin = this.mainStore.authAdmin.isSportipsAdmin;
      if (is_sportips_admin) return this.refund.amount_refundable + 1000;
      return this.refund.amount_refundable;
    },
    is_commande_admin() {
      if (!this.commande) return false;
      return this.commande.add_by_admin == "1";
    },
    refund_allowed() {
      let is_sportips_admin = this.mainStore.authAdmin.isSportipsAdmin;
      if (is_sportips_admin) return true;
      let is_module_end = this.mainStore.module.status == "apres_fermeture";
      if (is_module_end) return false;
      return true;
    },
    already_refunded() {
      let refunded = 0;
      for (let i = 0; i < this.inscription.refunds.length; i++) {
        refunded += parseFloat(this.inscription.refunds[i].amount_refunded);
      }
      return refunded;
    },
  },
  methods: {
    handle_close_response_dialog() {
      this.display_response_dialog = false;
      window.location.reload();
    },
    async proceed_to_refund() {
      this.display_confirm_dialog = false;
      this.onload = true;

      this.response_refund = {};
      this.response_refund = await this.refund.proceedToRefund();

      this.display_response_dialog = true;
      this.onload = false;
    },
    updateAmountToRefund() {
      let is_sportips_admin = this.mainStore.authAdmin.isSportipsAdmin;
      if (!is_sportips_admin) {
        if (this.refund.amount_to_refund > this.refund.amount_refundable) this.refund.amount_to_refund = this.refund.amount_refundable;
      }

      if (this.refund.amount_to_refund < 0) this.refund.amount_to_refund = 0;
      if (this.refund.amount_to_refund == "") this.refund.amount_to_refund = 0;
      if (isNaN(this.refund.amount_to_refund)) this.refund.amount_to_refund = 0;
      this.refund.amount_to_refund = parseFloat(this.refund.amount_to_refund);
      this.refund.updateAmountToRefund();
    },
  },

  async mounted() {
    this.inscription = this.item;
    this.refund.init(this.inscription);
    let req = await AdminService.getCommandeById(this.inscription.id_commande);
    if (req) {
      this.commande = req;
    }

  },
};
</script>

<style lang="scss" scoped></style>